// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H_eWsVt7tHYUmsEJ{padding:2px 0;display:grid;grid-column-gap:4px;grid-template-columns:20px 1fr}.H_eWsVt7tHYUmsEJ .VV9aYO30BkoEFPW7{width:20px;height:20px}.H_eWsVt7tHYUmsEJ .CiI6kZP8M_s8efXx{line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gZRgyK8doiw0nuXu{display:flex;align-items:center;gap:4px;justify-content:space-between}.gZRgyK8doiw0nuXu .irm7PeyCrI_LHdpK{display:flex;align-items:center;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBox": `H_eWsVt7tHYUmsEJ`,
	"userAvatar": `VV9aYO30BkoEFPW7`,
	"userName": `CiI6kZP8M_s8efXx`,
	"nameWithChips": `gZRgyK8doiw0nuXu`,
	"awaitingApprovalChips": `irm7PeyCrI_LHdpK`
};
export default ___CSS_LOADER_EXPORT___;
